var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 py-3 bg-grey-bg sm:px-6",class:{
        'flex flex-col md:flex-row-reverse md:items-center': _vm.isResponsive
    }},[_c('div',{staticClass:"flex-grow text-right",class:{
            'mb-3': _vm.showRequired,
            'md:mb-0': _vm.isResponsive
        }},[_vm._t("default")],2),_vm._v(" "),(_vm.showRequired)?_c('div',{staticClass:"text-sm leading-tight text-grey-darker"},[_vm._t("required",[_c('span',{staticClass:"text-red"},[_vm._v("•")]),_vm._v(" Required\n        ")])],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }